import { render, staticRenderFns } from "./InternalChangesTabs.vue?vue&type=template&id=6b26546c"
import script from "./InternalChangesTabs.vue?vue&type=script&lang=js"
export * from "./InternalChangesTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports